import type { DocumentMediaKind } from "@/features/document-viewport/types";

export function getDocumentMediaKind(filename: string, mimeType?: string): DocumentMediaKind {
  const normalizedMime = mimeType?.split(";")[0]?.toLowerCase().trim();
  const normalizedFilename = filename.trim().toLowerCase();

  if (normalizedMime === "application/pdf" || normalizedFilename.endsWith(".pdf")) {
    return "pdf";
  }

  if (
    normalizedMime?.startsWith("image/") ||
    /\.(png|jpe?g|gif|webp|bmp|svg|tiff?)$/i.test(normalizedFilename)
  ) {
    return "image";
  }

  return "unsupported";
}
